import { Badge } from 'cpool-components/general/Badge';
import { COLORS } from 'cpool-components/types';

type Props = {
    displayName: string;
    value: string;
    units?: string;
};

export const HeaderNotification: React.FC<Props> = ({ displayName, units, value }) => {
    const isNegative = value.startsWith('-');
    return (
        <Badge color={isNegative ? COLORS.RED : COLORS.WHITE}>
            {displayName}: {value} {units}
        </Badge>
    );
};
